import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import NavigationButton from './Components/NavigationButton/NavigationButton'

function NavigationButtons({ className, prevClass, nextClass }) {
  return (
    <div className={className}>
      <NavigationButton
        icon="ArrowLeft"
        customClass={classnames(
          'gallery-area-carousel__navigation-button',
          prevClass
        )}
        ariaLabel="Previous slide"
      />
      <NavigationButton
        icon="ArrowRight"
        customClass={classnames(
          'gallery-area-carousel__navigation-button',
          nextClass
        )}
        ariaLabel="Next slide"
      />
    </div>
  )
}

NavigationButtons.propTypes = {
  className: string.isRequired,
  prevClass: string.isRequired,
  nextClass: string.isRequired,
}

export default memo(NavigationButtons)
